import axios from 'axios';
import moment from 'moment';
// import store from '../store';

function errorHandler(error, reject) {
    console.log('Accrued : ',error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'keterangan', 'DimCol', 'DimVal','vendor', 'kodeacc', 'namaacc'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/accruedtmp${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data}= await axios.post("accruedtmp", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`accruedtmp/${obj.accrutmpkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    tmpactualcost(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                
                const url = `/accruedtrx/tmpactualcost/${moment(obj.tanggal).format('YYYY-MM-DD')}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    accruedtempwhactual(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                
                const url = `/accruedtrx/accruedtempwhactual/${moment(obj.tanggal).format('YYYY-MM-DD')}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxget(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'periode', 'keterangan', 'DimCol', 'DimVal', 'vendor', 'kodeacc', 'namaacc'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/accruedtrx${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    trxlist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','tglr1', 'tglr2', 'keterangan', 'DimCol', 'DimVal', 'vendor', 'kodeacc', 'namaacc', 'reversed'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/accruedtrx/list${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    trxexport(obj = {}) {
        // return new Promise(async (resolve, reject) => {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'DimColInfo', 'tgl1', 'tgl2','tglr1', 'tglr2', 'keterangan', 'DimCol', 'DimVal', 'vendor', 'kodeacc', 'namaacc', 'reversed'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/accruedtrx/listexportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'accrued_list.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxsave(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("accruedtrx", obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxsaveedit(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put("accruedtrx", obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxinsert(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('call accrued insert: ');
                const { data } = await axios.post("accruedtrx/insert", obj);
                console.log('accrued insert: ', data);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxupdate(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put("accruedtrx/update", obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxremove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`accruedtrx/${obj.accrujvkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    reverse(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`accruedtrx/reverse`, obj);
                resolve(data);
            } catch (error) {
                console.log('reverse error : ',error);
                errorHandler(error, reject)
            }
        });
    },
    reverseselected(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`accruedtrx/reverseselected`, obj);
                resolve(data);
            } catch (error) {
                console.log('reverse error : ',error);
                errorHandler(error, reject)
            }
        });
    },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url ;
            let str = '';
            try {
                const keys = ['nomor', 'tanggal', 'kodejurnal'];
                str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                url = `/buku/printjv`;
                 url += str;
                const { data } = await axios.get(url);
    
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
            });
    }

};